var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextCard = function SvgTextCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 2.84C.94 1.82 1.4 1 2.06 1H15.3c.65 0 1.12.82 1.04 1.84l-.9 12.33c-.07 1.01-.66 1.83-1.3 1.83H3.21c-.65 0-1.24-.81-1.31-1.83L1 2.84Z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.38 13.32a.2.2 0 0 1-.2.16H6.67a.2.2 0 0 1-.2-.24l1.5-6.63a.2.2 0 0 0-.2-.25H6.05a.2.2 0 0 1-.2-.24L6.12 5a.2.2 0 0 1 .2-.16h5.96a.2.2 0 0 1 .2.24l-.26 1.13a.2.2 0 0 1-.2.15h-1.9a.2.2 0 0 0-.2.16l-1.53 6.8Z"
  })));
};
export default SvgTextCard;